/**
 * Nodo dove montare Menu/Popper/Pickers: in Fullscreen API il portal di default su `body`
 * resta fuori dall’elemento fullscreen e non è visibile.
 */
export function getFullscreenPortalContainer() {
    if (typeof document === 'undefined') return undefined;
    return document.fullscreenElement ?? document.webkitFullscreenElement ?? document.body;
}
